import React, { useContext } from "react";
import ConfirmDialog from "~/components/general/ConfirmDialog";
import { SubscriptionContext, SubscriptionDispatchContext } from "../../..";
import { ApplicationFormContext } from ".";

const Confirm = () => {
  const { form = {} } = useContext(SubscriptionContext);
  const { showConfirm } = form;
  const dispatch = useContext(SubscriptionDispatchContext);
  const { handleConfirm } = useContext(ApplicationFormContext);
  return (
    <ConfirmDialog
      buttonText="Submit"
      className="w-[90vw] max-w-[600px]"
      onCancel={() => dispatch({ type: "hide_form_confirm" })}
      onConfirm={() => {
        dispatch({ type: "hide_form_confirm" });
        handleConfirm();
      }}
      open={showConfirm}
      title="Submit application?"
    >
      Your application will be submitted to the Dr Frost team for review. Your
      application cannot be modified after submission.
    </ConfirmDialog>
  );
};

export default Confirm;
